import NATIVE from "../../utils/native";
const base = {
  namespaced: true,
  state: {
    showInstrctionIcon: false,
    instrctionUrl: ""
  },
  getters: {},
  mutations: {
    checkPageHasInstruction(state, data) {
      let path = "";
      if (data) {
        path = data.path;
      }
      NATIVE.getStoreQueryTutorials().then(data => {
        console.log("从app获取的值", data);
        data = JSON.parse(data);
        const instrctionList = data.list || [];
        const curPath = path || location.pathname;
        const findInstrction = instrctionList.find(item => item.resourceParam === curPath);
        console.log("匹配到教程的值", findInstrction);
        if (findInstrction && findInstrction.tutorialUrl) {
          state.showInstrctionIcon = true;
          state.instrctionUrl = findInstrction.tutorialUrl;
        } else {
          state.showInstrctionIcon = false;
          state.instrctionUrl = "";
        }
        console.log(state.showInstrctionIcon, state.instrctionUrl);
      });
    }
  },
  actions: {
    async sendPhoneValidationCode({ rootState }, params = {}) {
      const data = await rootState.http("/basic/sendValidationCode", params);
      return data;
    },
    async sendPhoneValidationCodeByWeixin({ rootState }, params = {}) {
      const data = await rootState.http("/wechat/sendValidationCode", params);
      return data;
    },

    async userBindPhone({ rootState }, params = {}) {
      const data = await rootState.http("/userAccount/third/weixinOfficialAccount/bindMobile", params);
      return data;
    },
    async userBindStore({ rootState }, params = {}) {
      const data = await rootState.http("/userAccount/third/weixinMiniprogram/followStore", params);
      return data;
    },
    async getWeixinSignature({ rootState }, params = {}) {
      const data = await rootState.http("/basic/getOfficialAccountJsSignature", params);
      return data;
    },
    async createJumpMiniappQr({ rootState }, params = {}) {
      const data = await rootState.http("/campaign/fission/getFissionQrCodeUrl", params);
      return data;
    },
    async createStaticMiniappQr({ rootState }, params = {}) {
      const data = await rootState.http("/basic/wechat/mp/findStaticPageQrCode", params);
      return data;
    },
    async queryStoreInfo({ rootState }, params = {}) {
      const data = await rootState.http("/externalStore/getStore/v2", params);
      return data;
    },
    async querySotreBaseInfo({ rootState }, params = {}) {
      const data = await rootState.http("/store/getStoreInfo", params);
      return data;
    },
    async officialAccountBindPhone({ rootState }, params = {}) {
      const data = await rootState.http("/wechat/bindMobile", params);
      return data;
    },
    async login({ rootState }, params = {}) {
      const data = await rootState.http("/userAccount/login", params);
      return data;
    },
    async getUserData({ rootState, commit }, params = {}) {
      const data = await rootState.http("/userAccount/getUserAccount", params);
      return data;
    },
    async setCurrentStore({ rootState, commit, dispatch }, params = { orgCode: "" }) {
      const data = await rootState.http("/staff/setCurrentStore", params);
      return data;
    },
    async codeExchangeOpenid({ rootState, commit, dispatch }, params = {}) {
      const data = await rootState.http("/business/official/user/findOpenId", params, { errorMessage: false });
      return data;
    },
    async loginByOfficial({ rootState, commit, dispatch }, params = {}) {
      const data = await rootState.http("/userAccount/business/official/login", params);
      return data;
    },
    async queryDictionaryList({ rootState, commit, dispatch }, params = {}) {
      const { data } = await rootState.http("/basic/queryDictionaryList", params);
      return data.list || [];
    }
  }
};

export default base;



// WEBPACK FOOTER //
// ./src/store/modules/base.js